/**
 * LTI 1.3 Advantage Scope URLs
 * IMS Global Learning Consortium LTI Advantage Service Scopes
 */

import { AgsScopes } from 'types/LtiAdvantage';

export const LTI_AGS_SCOPES = {
  SCORE: 'https://purl.imsglobal.org/spec/lti-ags/scope/score',
  LINEITEM: 'https://purl.imsglobal.org/spec/lti-ags/scope/lineitem',
  LINEITEM_READONLY:
    'https://purl.imsglobal.org/spec/lti-ags/scope/lineitem.readonly',
  RESULT_READONLY:
    'https://purl.imsglobal.org/spec/lti-ags/scope/result.readonly',
} as const;

export const LTI_NRPS_SCOPE =
  'https://purl.imsglobal.org/spec/lti-nrps/scope/contextmembership.readonly';

export const LTI_DEEP_LINKING_SCOPE =
  'https://purl.imsglobal.org/spec/lti-dl/scope/deeplinking.settings';

/**
 * Mapping of form field names to LTI scope URLs
 */
export const AGS_SCOPE_MAPPING: Record<keyof AgsScopes, string> = {
  score: LTI_AGS_SCOPES.SCORE,
  lineitem: LTI_AGS_SCOPES.LINEITEM,
  lineitemReadonly: LTI_AGS_SCOPES.LINEITEM_READONLY,
  resultReadonly: LTI_AGS_SCOPES.RESULT_READONLY,
};

/**
 * Configuration for LTI Advantage AGS scopes
 */
export interface AgsScopeConfig {
  id: string;
  key: keyof typeof AGS_SCOPE_MAPPING;
  label: string;
  disabled?: boolean;
}

export const AGS_SCOPES_CONFIG: AgsScopeConfig[] = [
  {
    id: 'agsScopes.score',
    key: 'score',
    label: "'score' - Tool can publish score updates to its line items",
    disabled: false,
  },
  {
    id: 'agsScopes.lineitem',
    key: 'lineitem',
    label:
      "'lineitem' - Tool can fully manage its line items, including adding and removing line items (disabled)",
    disabled: true,
  },
  {
    id: 'agsScopes.lineitemReadonly',
    key: 'lineitemReadonly',
    label:
      "'lineitem.readonly' - Tool can query the line items, no modification is allowed",
    disabled: false,
  },
  {
    id: 'agsScopes.resultReadonly',
    key: 'resultReadonly',
    label:
      "'result.readonly' - Tool can access current results for its line items",
    disabled: false,
  },
];
